import React from "react";
import styled from 'styled-components'

import {
  Container,
  Row,
} from "reactstrap";

import IndexNavbar from "components/Navbars/IndexNavbar.js";
import DemoFooter from "components/Footers/DemoFooter.js";
import LogisticsBackground from 'assets/img/logistics123.png';
import train1 from 'assets/img/train/train1.png'
import train2 from 'assets/img/train/train2.jpg'
import train3 from 'assets/img/train/train3.png'
import train4 from 'assets/img/train/train4.png'
import train5 from 'assets/img/train/train5.png'
import train6 from 'assets/img/train/train6.jpg'
import train7 from 'assets/img/train/train7.png'
import train8 from 'assets/img/train/train8.jpg'
import train9 from 'assets/img/train/train9.jpg'
import train10 from 'assets/img/train/train10.png'
import train11 from 'assets/img/train/train11.jpg'
import train12 from 'assets/img/train/train12.png'
import train13 from 'assets/img/train/train13.png'
import train14 from 'assets/img/train/train14.png'
import train15 from 'assets/img/train/train15.png'
const MainText = styled.h5`
`

const BackImage = styled.img`
  height: 600px;
  width: 100%;
`
const TrainTitle = styled.h4`
    text-align: center;
`
const ImgStyled = styled.img`
  height: 600px;
  width: 100%;
`
const ImgStyled2 = styled.img`
  width: 100%;
  height: 1200px;
`
const ImgStyled3 = styled.img`
  width: 100%;
  height: 150px;
`
function ProfilePage() {

  return (
    <>
      <IndexNavbar />
      <BackImage src={LogisticsBackground} alt='logistics'/>
      <Container>
      <Row>
        <MainText>
       <TrainTitle> <b>Железнодорожные грузоперевозки</b> </TrainTitle>
        Компания SIA AUSTRUM LOGISTICS предлагает транспортировку груза железнодорожным транспортом. Благодаря своему опыту мы сможем организовать транспортировку груза всеми видами вагонов, контейнеров, платформ ,а так же танк контейнерами и цистернами.
        <h4>Наши услуги по железнодорожным перевозкам: </h4>
        <ul>
            <li>
                перевозка грузов любой сложности;
            </li>
            <li>
                постоянный контроль движения груза;
            </li>
            <li>
                разработка схем крепления и перевозки крупногабаритных и тяжеловесных грузов;
            </li>
            <li>
                cкладирование.
            </li>
        </ul>
        <TrainTitle> <b>Основные типы железнодорожных грузовых вагонов и их характеристики: </b> </TrainTitle>
        <h4><b>КРЫТЫЙ ВАГОН </b></h4>
        <div>
          <ImgStyled src={train2} alt="train2" />
          <br/>
          <ImgStyled src={train1} alt="train2" />
        </div>
        <br/>
        <h7>К классу крытых вагонов также относятся:</h7>
        <br/>
        <br/>
        <div>
          <ImgStyled2 src={train3} alt="train3" />
        </div>
        <h4><b>ПОЛУВАГОН</b></h4>
        <div>
        <ImgStyled src={train4} alt="train4" />
        <br/>
        <ImgStyled src={train5} alt="train5" />
        <br />
        <h4><b>ТРАНСПОРТЕРЫ</b></h4>
        <br />
        <ImgStyled src={train6} alt="train6" />
        <ImgStyled src={train7} alt="train7" />
        <h4><b>ЦИСТЕРНЫ</b></h4>
        <br />
        <ImgStyled src={train8} alt="train8" />
        <ImgStyled3 src={train12} alt="train12" />
        <h4><b>ДУМПКАР</b></h4>
        <br />
        <ImgStyled src={train9} alt="train9" />
        <ImgStyled3 src={train13} alt="train13" />
        <h4><b>ХОППЕР</b></h4>
        <br />
        <ImgStyled src={train10} alt="train10" />
        <ImgStyled3 src={train14} alt="train14" />
        <h4><b>ВАГОН-АВТОМОБИЛЕВОЗ</b></h4>
        <br />
        <ImgStyled src={train11} alt="train11" />
        <ImgStyled3 src={train15} alt="train15" />
        </div>
        </MainText>
      </Row>
      <DemoFooter />
      </Container>
    </>
  );
}

export default ProfilePage;
